var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadSick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "126px",
    viewBox: "0 0 117 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "100C7342-A2AC-474E-B0AE-A081D1960377") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-661.000000, -378.000000)",
    strokeWidth: 4.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(664.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.33713,120.73134 C55.33713,114.13614 53.79813,103.22844 72.14673,106.07334 C75.55353,106.60314 77.81643,103.95624 79.47063,100.33134 C80.30403,98.50584 64.76523,104.08314 65.28633,92.12784 C65.68533,82.97274 83.41173,87.24234 84.30663,85.40004 C85.39983,83.16084 86.64543,81.42744 89.22903,80.96544 C91.11003,80.62764 93.24573,81.25164 94.83303,79.88814 C96.15933,78.76074 96.44853,76.78284 95.89863,75.18564 C95.89863,75.18564 91.25103,65.90724 86.61303,58.40124 C83.37753,53.17434 85.00233,48.35364 85.00233,42.50694 C85.00233,19.02804 65.97423,0.00024 42.50673,0.00024 C19.03263,0.00024 3e-05,19.02804 3e-05,42.50694 C3e-05,49.94364 1.92063,56.94084 5.31513,63.09264 C16.71033,85.10664 15.00003,120.73134 15.00003,120.73134",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.52122,93.09471 C81.21282,93.09471 89.75772,93.01671 92.62902,95.88831 C95.50062,98.75961 96.88062,104.66721 102.86622,104.66721",
    id: "Stroke-3",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.56716,101.67459 C89.43846,104.54589 90.81846,110.45379 96.80436,110.45379",
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86619,94.9917 C105.73779,97.863 111.64539,96.7848 111.64539,102.7704",
    id: "Stroke-7",
    stroke: "#ED7330"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadSick);
export default __webpack_public_path__ + "static/media/headSick.826c9781.svg";
export { ForwardRef as ReactComponent };